/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Franchise_Access_ActiveInputs */

const cs_franchise_access_active = /** @type {(inputs: Franchise_Access_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přístup aktivní`)
};

const en_franchise_access_active = /** @type {(inputs: Franchise_Access_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Access active`)
};

/**
* | output |
* | --- |
* | "Access active" |
*
* @param {Franchise_Access_ActiveInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const franchise_access_active = /** @type {((inputs?: Franchise_Access_ActiveInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Franchise_Access_ActiveInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_franchise_access_active(inputs)
	return cs_franchise_access_active(inputs)
});